<script>
  import { ignore } from '../../../Common/tools';
  import { onDestroy, onMount } from 'svelte';
  import { External, M } from '../../../external';
  import getNewThread from '../util/getNewThread';
  import SingleWallSettingsPopup from '../SingleWall/SingleWallSettingsPopup.svelte';

  export let data,
    onChange = ignore,
    refreshUI = ignore;

  let sortable, jqSortable;

  const onAddNewWall = () => {
    const newWall = getNewThread();
    data.walls = [...data.walls, newWall];
    onEditWall(data.walls.length - 1);
  };

  const onRemoveWall = function (idx) {
    External.Tools.prompt(M.DELETE, M.DEL_CONFIRM, () => {
      data.walls.splice(idx, 1);
      data.walls = data.walls;
      onChange();
      refreshUI();
    });
  };

  const onEditWall = function (idx) {
    External.Tools.showWindow({
      isModal: false,
      icon: External.Popup.ICON_ADD,
      width: 500,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(
            new SingleWallSettingsPopup({
              target: popup.getContentArea(),
              props: {
                wall: data.walls[idx],
                onChange: onChange,
                refreshUI: refreshUI,
                showGroupStyleSettings: data.view !== 'sidebar-view'
              }
            })
          );
        },
        onBeforeHide: (popup, ui) => {
          if (!data.walls[idx].resourceId) {
            External.Tools.showError(M.SELECT_A_CHANNEL);
            return false;
          }

          data.walls = data.walls;

          return true;
        }
      }
    });
  };

  onMount(() => {
    jqSortable = External.$(sortable);
    jqSortable.sortable({
      items: '.form-step-wrapper',
      handle: '.move-icon',
      containment: 'parent',
      tolerance: 'pointer',
      axis: 'y',
      start: (event, ui) => {
        ui.item.data('idx', ui.item.index());
      },
      stop: (event, ui) => {
        let newIdx = ui.item.index();
        let oldIdx = ui.item.data('idx') || 0;
        if (newIdx !== oldIdx) {
          let elem = data.walls[oldIdx];
          data.walls.splice(oldIdx, 1);
          data.walls.splice(newIdx, 0, elem);
          data.walls = data.walls;
          onChange();
          refreshUI();
        }
      }
    });

    if (data.walls.length === 1 && !data.walls[0].resourceId) {
      onEditWall(0);
    }
  });

  const onGroupNameChanged = (idx, newName) => {
    data.walls[idx].groupSettings.name = newName;
    data.walls = data.walls;
    onChange();
    refreshUI();
  };

  onDestroy(() => {
    jqSortable.sortable('destroy');
    jqSortable = null;
  });
</script>

<span class="light-gray-text t-center col20 f-left mt-15 mb-5"
  >{M.DEFINE_CHANNELS}</span>
<div bind:this={sortable} class="col20 f-left ui-sortable form-admin-style-2 mb-5">
  {#each data.walls as wall, index (index + wall.groupSettings.name)}
    <div class="form-step-wrapper flex align-center space-between">
      <div class="flex align-center col20">
        <span class="move-icon button-tooltip flex-none ui-sortable-handle flex-none" data-tooltip="simpleMove"></span>
        <input
          type="text"
          class="step-name flex-1"
          value={wall.groupSettings.name}
          on:blur={(e) => {
            onGroupNameChanged(index, e.target.value);
          }} />
      </div>
      <div class="buttons-wrapper flex-none">
        <a on:click={() => onEditWall(index)} data-tooltip="simpleEdit" class="middle-button blue ml-10">{M.SETTINGS}</a>
        <a
          class:none={data.walls.length === 1}
          on:click={() => onRemoveWall(index)}
          data-tooltip="simpleDelete"
          class="delete delete-icon modify button-tooltip light-gray-icon circle-effect">
          <i class="material-icons-outlined">delete</i>
        </a>
      </div>
    </div>
  {/each}
</div>

<div class="col20 f-left t-center mt-5">
  <a on:click={onAddNewWall} class="middle-button blue with-icon f-none inline-block">{M.ADD_CHANNEL}</a>
</div>
